import type { AppController } from '@/engine/app/App.controller';
import { useEffect, useRef } from 'react';

export const useInitSaveCaseSubscriptionsAfterInitialization = (appController: AppController): void => {
  const hasRunRef = useRef(false);
  useEffect(() => {
    if (appController.hasAppInitializationCompleted) {
      if (hasRunRef.current) {
        console.error('initSaveCaseSubscriptons already run once');
        return;
      }

      // deferring to next event loop tick
      setTimeout(() => {
        appController.initSaveCaseSubscriptons();
        hasRunRef.current = true;
      }, 0);
    }
  }, [appController, appController.hasAppInitializationCompleted]);
};
